<template lang="pug">
.limit-list
  .search-filter
    input-search(@search="search" :clearSearch="true" placeholder="查找小区")
  el-table(
    empty-text="暂无结果，换个名称重新试试吧～"
    :data="tableData" size="mini" stripe border height="calc(100% - 40px)"
    ref="table"
    @select="manualSelect"
    @select-all="allChange")
    el-table-column(type="selection" width="55")
    el-table-column(label="小区名称" align="center" prop="name")
    el-table-column(label="地址" align="center" prop="address")
    el-table-column(label="限制内容" align="center")
      template(slot-scope="{row}")
        span(v-if="row.limitList") 限制素材：{{row.limitList.toString()}}
        span(v-if="row.remark" style="margin-left: 5px;") 备注说明：{{row.remark}}
</template> 

<script>
import InputSearch from '../../../components/InputSearch.vue'
export default {
  name: 'CmLimitList',
  props: ['data', 'chooseList'],
  components: { InputSearch },
  data () {
      return {
        tableData: [],
        choose: [...this.chooseList],
      }
  },
  watch: {
    data: {
      immediate: true,
      handler (v) {
        this.allData = v
        this.tableData = v
      }
    }
  },
  mounted () {
    this.fillCheck()
  },
  methods: {
    toggleItem (item, type) {
      this.$refs.table.toggleRowSelection(item, type || false)
    },
    manualSelect(data, row) {
      let curId = row.guid
      let rids = data.map(item => item.guid)
      let cids = this.choose.map(item => item.guid)
      let cIdx = cids.indexOf(curId)
      if (rids.length) {
        if (rids.indexOf(curId) > -1) { // 新增勾选某项
          if (cIdx === -1) this.choose.push(row)
        } else { // 取消勾选某项
          if (cIdx > -1) this.choose.splice(cIdx, 1)
        }
      } else { // 移除table当前页仅剩的最后一个选中项
        if (cIdx > -1) this.choose.splice(cIdx, 1)
      }
    },
    cancelOrSelectItems(nbData, cancel) { // cancel:是否取消选中
      let pageGids = nbData.map(item => item.guid)
      let chooseIds = this.choose.map(item => item.guid)
      if (cancel) {
        let toDeleteIdx = pageGids.map(nid => chooseIds.indexOf(nid)).filter(idx => idx > -1) // 找出待移除项在已选项中的索引值
        toDeleteIdx.sort((a,b) => b - a) // 倒序排序，先删除索引值大的项，否则多次调splice时会出问题(删除失败)
        for (let i = 0; i < toDeleteIdx.length; i++) {
          this.choose.splice(toDeleteIdx[i], 1)
        }
      } else {
        for (let j = 0; j < nbData.length; j++) {
          let nbItem = nbData[j]
          if (chooseIds.indexOf(nbItem.guid) === -1) { // 已选项中不存在该项，则添加进去
            this.choose.push(nbItem)
          }
        }
      }
    },
    allChange(data) {
      if (!data.length) { // table当前页全部取消
        this.cancelOrSelectItems(this.tableData, true)
      } else { // 全选当前页数据
        this.cancelOrSelectItems(data, false)
      }
    },
    fillCheck () {
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
        if (this.choose.length > 0) {
          this.$refs.table.clearSelection()
          let guids = this.choose.map(el => el.guid)
          this.tableData.forEach(el => {
            if (guids.indexOf(el.guid) > -1) this.toggleItem(el, true)
          })
        }
      })
    },
    search (str) {
      this.tableData = !str ? this.allData : this.allData.filter(el => el.name.indexOf(str) > -1)
      if (!this.isEmpty(this.tableData)) this.fillCheck()
    }
  }
}
</script>

<style lang="sass" scoped>
.limit-list
  height: 100%
  .search-filter
    height: 30px
    margin-bottom: 10px
    text-align: center
  ::v-deep .el-table__empty-block
    border-bottom: 1px solid rgba(233,233,233,1)
    height: auto
    .el-table__empty-text
      background: #fff
      color: #999
      font-size: 14px
      height: 60px
      line-height: 60px
      width: 100%
      text-align: center
</style>
